import { type ReactNode, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { BrandLogo } from '@/components/common/BrandLogo';
import splitStyles from '@/components/layout/SplitScreenLayout/SplitScreenLayout.module.css';
import styles from '../WorkspaceOnboardingPage.module.css';

export const LeftPanelContent = memo(function LeftPanelContent(): ReactNode {
  const { t } = useTranslation();

  return (
    <>
      <div className={`${splitStyles.fadeElement} ${splitStyles.fadeDelay0}`}>
        <BrandLogo linkToHome />
      </div>

      <div className={styles.leftCenterBlock}>
        <h1
          className={`${styles.leftHeading} ${splitStyles.fadeElement} ${splitStyles.fadeDelay1}`}
        >
          {t('workspace.onboarding.headingPrefix')}{' '}
          <span className={styles.brandAccent}>GeoMarkup</span>!
        </h1>
        <p
          className={`${styles.leftDescription} ${splitStyles.fadeElement} ${splitStyles.fadeDelay2}`}
        >
          {t('workspace.onboarding.leftDescription')}
        </p>
      </div>

      <p
        className={`${styles.leftFooter} ${splitStyles.fadeElement} ${splitStyles.fadeDelay3}`}
      >
        {t('workspace.onboarding.leftFooter')}
      </p>
    </>
  );
});
